import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { convertBooleanToStatus, convertStringToStringDouble } from "../../../../utils/ConverterUtils";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";

const CardFlagNew = () => {
    
    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    // Mesma faixa (0-100%) vale para as taxas de crédito, débito e Pix.
    const feePercentageSchema = () => Yup.string()
        .test('range', t("validation.invalid.fee_percentage"), (value) => {
            if (value == null || value === '') {
                return true;
            }
            const parsed = parseFloat(convertStringToStringDouble(value));
            return !isNaN(parsed) && parsed >= 0 && parsed <= 100;
        });

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.name')),
        creditFeePercentage: feePercentageSchema(),
        debitFeePercentage: feePercentageSchema(),
        pixFeePercentage: feePercentageSchema()
    });

    function onReset() {
        formik.resetForm({
            values: {
                name: '',
                creditFeePercentage: '',
                debitFeePercentage: '',
                pixFeePercentage: ''
            }
        });
        setStatus(true);
    }

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            name: '',
            creditFeePercentage: '',
            debitFeePercentage: '',
            pixFeePercentage: ''
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                name: values.name,
                creditFeePercentage: values.creditFeePercentage !== '' ? convertStringToStringDouble(values.creditFeePercentage) : null,
                debitFeePercentage: values.debitFeePercentage !== '' ? convertStringToStringDouble(values.debitFeePercentage) : null,
                pixFeePercentage: values.pixFeePercentage !== '' ? convertStringToStringDouble(values.pixFeePercentage) : null,
                status: convertBooleanToStatus(status)
            }
            
            // Aciona a api
            sendToApi(Api.main.card_flag, payload, () => {
                if(entityData == null) {
                    onReset();
                } else {
                    navigate(MenuConfig.main.card_flag.route);
                }
            }, (error) => {
                ApiError(error);
                formik.setSubmitting(false);
            });
        },
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('main')}
                childMenu={t('card_flags')}
                activeMenu={t('new')}
                child={<Form formik={formik} status={status} setStatus={setStatus} entityData={entityData}/>}
                setEntityData={setEntityData}
                path={Api.main.card_flag}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.main.card_flag.route}
            />
        </>
    );
}

export default CardFlagNew;
